import { GetStaticProps, GetStaticPropsContext } from 'next';
import { Image, Link, Typography } from 'beek-design-system';
import { useTranslations } from 'next-intl';
import Const from 'src/config/Const';
import Footer from 'src/components/Common/Footer';
import NavBar from 'src/components/Common/NavBar';
import styled from 'styled-components';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-top: 6.44rem;
  background-color: var(--white);
`;

const LinkWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 3.125rem;
  @media ${({ theme }): string => theme.devices.mobileM} {
    margin-bottom: 4.5625rem;
  }
  @media ${({ theme }): string => theme.devices.mobileL} {
    margin-bottom: 6rem;
  }
`;

const ErrorBody = styled(Typography)`
  white-space: pre-wrap;
  text-align: center;
  margin-bottom: 3.5rem;
  @media ${({ theme }): string => theme.devices.laptop} {
    margin-bottom: 3rem;
  }
`;

const ErrorTitle = styled(Typography)`
  white-space: pre-wrap;
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  @media ${({ theme }): string => theme.devices.laptop} {
    margin-top: 2.5rem;
    margin-bottom: 1rem;
  }
`;

const Custom404 = (): JSX.Element => {
  const t = useTranslations('error_not_found');

  return (
    <>
      <NavBar />
      <PageContainer>
        <Image
          url={`${Const.cdnUrl}/design-system/images/fallbacks/error404.webp`}
          type="not_found"
          alt="Page not found error."
        />
        <ErrorTitle type="headline4">{`${t('title.text')}`}</ErrorTitle>
        <ErrorBody type="body1">{`${t('body.text')}`}</ErrorBody>
        <LinkWrapper>
          <Link
            marginRight="0.375rem"
            typographyType="subtitle1"
            href="/"
            textDecoration="none"
          >
            {`${t('links.home')}`}
          </Link>
          <Typography type="subtitle1" marginRight="0.375rem">
            |
          </Typography>
          <Link
            marginRight="0.375rem"
            typographyType="subtitle1"
            href="/html_sitemap/audiolibros_a.html"
            textDecoration="none"
          >
            {`${t('links.audiobooks')}`}
          </Link>
          <Typography type="subtitle1" marginRight="0.375rem">
            |
          </Typography>
          <Link typographyType="subtitle1" href="/listas" textDecoration="none">
            {`${t('links.articles')}`}
          </Link>
        </LinkWrapper>
      </PageContainer>
      <Footer />
    </>
  );
};

export const getStaticProps: GetStaticProps = async (
  context: GetStaticPropsContext
) => ({
  props: {
    messages: {
      ...require(`src/messages/article/${context.locale}.json`),
      ...require(`src/messages/404/${context.locale}.json`),
    },
  },
});

export default Custom404;
